import React, { FC, ReactNode } from 'react';
import { NavHashLink } from 'react-router-hash-link';

import { Typography } from 'Modules/ui3';


interface NavTabProps {
    title: ReactNode;
    route: string;
    isWhite?: boolean;
}

export const NavTab: FC<NavTabProps> = ({ title, route, isWhite }) => (
    <Typography
        // @ts-ignore
        component={NavHashLink}
        to={`/${route}`}
        exact
        smooth
        px={4}
        py={3}
        variant='mediumBody2'
        fontFamily='Hauora'
        fontWeight={600}
        color={isWhite ? '#242424' : '#fff'}
        borderRadius={5}
        bgcolor={isWhite ? 'transparent' : 'rgba(255, 255, 255, 0.04)'}
        sx={{
            ...!isWhite && {
                backdropFilter: 'blur(8px)',
            },
            '&:hover': {
                color: isWhite ? '#242424' : '#fff',
            },
        }}
    >
        {title}
    </Typography>
);
